// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/auth/v1/featurepermission.proto (package chalk.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/auth/v1/featurepermission.proto.
 */
export const file_chalk_auth_v1_featurepermission: GenFile = /*@__PURE__*/
  fileDesc("CiVjaGFsay9hdXRoL3YxL2ZlYXR1cmVwZXJtaXNzaW9uLnByb3RvEg1jaGFsay5hdXRoLnYxIvgBChJGZWF0dXJlUGVybWlzc2lvbnMSOQoEdGFncxgBIAMoCzIrLmNoYWxrLmF1dGgudjEuRmVhdHVyZVBlcm1pc3Npb25zLlRhZ3NFbnRyeRJBChJkZWZhdWx0X3Blcm1pc3Npb24YAiABKA4yIC5jaGFsay5hdXRoLnYxLkZlYXR1cmVQZXJtaXNzaW9uSACIAQEaTQoJVGFnc0VudHJ5EgsKA2tleRgBIAEoCRIvCgV2YWx1ZRgCIAEoDjIgLmNoYWxrLmF1dGgudjEuRmVhdHVyZVBlcm1pc3Npb246AjgBQhUKE19kZWZhdWx0X3Blcm1pc3Npb24qwgEKEUZlYXR1cmVQZXJtaXNzaW9uEiIKHkZFQVRVUkVfUEVSTUlTU0lPTl9VTlNQRUNJRklFRBAAEhwKGEZFQVRVUkVfUEVSTUlTU0lPTl9BTExPVxABEiUKIUZFQVRVUkVfUEVSTUlTU0lPTl9BTExPV19JTlRFUk5BTBACEhsKF0ZFQVRVUkVfUEVSTUlTU0lPTl9ERU5ZEAMSJwojRkVBVFVSRV9QRVJNSVNTSU9OX0FMTE9XX0RPV05TVFJFQU0QBEIQWg5hdXRoL3YxO2F1dGh2MWIGcHJvdG8z");

/**
 * @generated from message chalk.auth.v1.FeaturePermissions
 */
export type FeaturePermissions = Message<"chalk.auth.v1.FeaturePermissions"> & {
  /**
   * @generated from field: map<string, chalk.auth.v1.FeaturePermission> tags = 1;
   */
  tags: { [key: string]: FeaturePermission };

  /**
   * @generated from field: optional chalk.auth.v1.FeaturePermission default_permission = 2;
   */
  defaultPermission?: FeaturePermission;
};

/**
 * Describes the message chalk.auth.v1.FeaturePermissions.
 * Use `create(FeaturePermissionsSchema)` to create a new message.
 */
export const FeaturePermissionsSchema: GenMessage<FeaturePermissions> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_featurepermission, 0);

/**
 * @generated from enum chalk.auth.v1.FeaturePermission
 */
export enum FeaturePermission {
  /**
   * @generated from enum value: FEATURE_PERMISSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Allow unfettered access to the feature.
   * This permission is the default permission for all features.
   *
   * @generated from enum value: FEATURE_PERMISSION_ALLOW = 1;
   */
  ALLOW = 1,

  /**
   * Allow access to the feature only within a query plan,
   * and do not return the feature to the client directly.
   *
   * @generated from enum value: FEATURE_PERMISSION_ALLOW_INTERNAL = 2;
   */
  ALLOW_INTERNAL = 2,

  /**
   * Deny access to the feature, even if the user hasn't requested
   * access to this feature directly, but needs the feature to compute
   * the result of the query.
   *
   * @generated from enum value: FEATURE_PERMISSION_DENY = 3;
   */
  DENY = 3,

  /**
   * Allow the feature, and additionally permit any feature derived from it to be
   * computed and returned even when it would otherwise be blocked by default-deny.
   * This keeps a sensitive feature fully blocked upstream while an anonymizing
   * aggregation derived from it is served. e.g. with A (sensitive) -> B (aggregation)
   * -> C -> D and B tagged ALLOW_DOWNSTREAM, C and D are allowed as query outputs
   * while A stays denied.
   *
   * Only meaningful under default-deny. An output is allowed iff it is "cleared":
   * a feature is cleared when it is tagged ALLOW_DOWNSTREAM, is a caller-supplied
   * input, or has parents that are all themselves cleared.
   *
   * @generated from enum value: FEATURE_PERMISSION_ALLOW_DOWNSTREAM = 4;
   */
  ALLOW_DOWNSTREAM = 4,
}

/**
 * Describes the enum chalk.auth.v1.FeaturePermission.
 */
export const FeaturePermissionSchema: GenEnum<FeaturePermission> = /*@__PURE__*/
  enumDesc(file_chalk_auth_v1_featurepermission, 0);

